module.exports = __webpack_public_path__ + "static/media/settings_white6acc27e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sidenav/images/settings_white.svg
// module id = 493
// module chunks = 0